import { Navigate, useLocation } from 'react-router-dom';

function PrivateRoute({ children }) {
  const location = useLocation();
  if (!localStorage.getItem('user')) {
    // 携带来源路径，登录成功后回跳
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
  return children;
}

export { PrivateRoute };
